import { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { IoIosRemoveCircleOutline, IoMdAddCircleOutline } from "react-icons/io";
import { GoDiffAdded } from "react-icons/go";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useEffect } from "react";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import sendRequest, { sendRequestAPI2 } from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import logo from "assets/images/sitelogo.svg";
import "./round.scss";

const EditProductAdmin = ({ productDetail, maxPrice, setUpdater }) => {
  const auth = useContext(WithAuthentication);
  let bId = useParams();
  let type = productDetail.business[0]?.type;
  const [show, setShow] = useState(false);
  const [disabledInput, setDisabledInput] = useState(false);
  const [priceRange, setPriceRange] = useState({ max: "", min: "" });
  const [saleTerms, setSaleTerms] = useState({
    productId: "",
    singleSaleTerms: {
      deliveryPrice: "",
      discountDateFrom: "",
      discountDateTo: "",
      minCount: "",
      maxCount: "",
      step: "",
      price: "",
      discount: ""
    },
    groupSaleTerms: {
      deliveryPrice: "",
      status: productDetail.have_group_sale == "1" ? true : false,
      rangeList: [
        { min: 1, max: 1, price: "", minCount: "", maxCount: "", step: "1" }
      ]
    }
  });
  const [details, setDetails] = useState({
    business: {},
    product: [
      {
        bodytxt: "",
        url: "",
        title: "",
        rating_count: "",
        avg_rating: "",
        interest_rates: 1
      }
    ],
    product_id: "",
    renge: [
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0
      },
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0
      },
      {
        to_count: "",
        from_count: "",
        to_price: "",
        from_price: "",
        saled_count: 0
      }
    ]
  });
  const [validateTxt, setValidateTxt] = useState(false);
  const [singleFlag, setSingleFlag] = useState(false);
  const [groupFlag, setGroupFlag] = useState(false);
  const [tooltipSingle, setTooltipSingle] = useState("");
  const [tooltipGroup, setTooltipGroup] = useState("");
  const [situation, setSituation] = useState({ add: false, edit: false });
  const [textError, setTextError] = useState({ single: "", group: "" });
  const [singleTxt, setSingleTxt] = useState({ single: "", group: "" });
  const flagHandler = type => {
    if (type == "group") {
      setGroupFlag(true);
    } else if (type == "single") {
      setSingleFlag(true);
    }
  };
  useEffect(() => {
    // saleTerms.singleSaleTerms.status
    details.is_single && details.is_single == "1"
      ? setTooltipSingle("غیر فعال")
      : setTooltipSingle("فعال");
  }, [details.is_single]);
  useEffect(() => {
    saleTerms.groupSaleTerms.status
      ? setTooltipGroup("غیر فعال")
      : setTooltipGroup(" فعال");
  }, [saleTerms.groupSaleTerms.status]);

  useEffect(() => ReactTooltip.rebuild());

  const isLastRange = index => {
    // return saleTerms.groupSaleTerms.rangeList.length == index + 1;
    return details.renge.length == index + 1;
  };
  const changeHandler = (parent, names, values, index) => {
    // if (details.renge[0]?.saled_count && details.renge[0]?.saled_count == "0") {
    switch (parent) {
      case "main":
        setDetails(prev => {
          return { ...prev, [names]: values };
        });
        break;
      case "range":
        setDetails(prev => {
          let temp = [...details.renge];
          temp[index] = { ...temp[index], [names]: values };
          return { ...prev, renge: [...temp] };
        });
        break;
    }
    // } else {
    //   toast.error(
    //     "برای تعریف شرایط فروش جدید ، باید فروش محصولات قبلی تمام شود!"
    //   );
    // }
  };

  const priceChecker = min => {
    if (min > maxPrice) {
      toast.error(`حداکثر مبلغ  ${addCommas(maxPrice)} میتواند باشه`);
    }
  };

  const checkInventory = async function() {
    let temp = "";
    if (details.is_single == "1" && details.have_group_sale == "1") {
      temp = "both";
    } else if (details.is_single == "1") {
      temp = "single";
    } else if (details.have_group_sale == "1") {
      temp = "group";
    }
    let x = new Promise(function(resolve) {
      sendRequest("check_products_inventory", {
        business_id: bId.businessId,
        product_id: details.product_id,
        new_inventory:
          +(details.is_single == "1" ? details.itemcount : 0) +
          +(details.have_group_sale == "1"
            ? details.renge[details.renge.length - 1].to_count
            : 0),
        // is_single: saleTerms.singleSaleTerms.status ? 1 : 0,
        type: temp
      }).then(data => {
        let y = data.data.status == "1" ? true : false;
        resolve(y);
        if (data.data.status == -1) {
          toast.error(
            "موجودی شما در سیستم کمتر از مقداری است که تعریف کرده اید."
          );
        }
      });
    });

    return x;
  };

  const groupEditProduct = async function() {
    let x = JSON.stringify(
      details.renge.map((value, index) => {
        return [
          // +value.minCount,
          +value.max_num,
          +value.from_price,
          +saleTerms.groupSaleTerms.rangeList[index + 1]?.from_price,
          +value.from_count,
          +value.to_count,
          +value.step
        ];
      })
    );

    // is_main_shop: 1
    // productPricing: [[1,111111,2222222,1,111,1],[1,2222222,333331,112,222,1],[1,333331,null,223,333,1]]
    const fd = new FormData();
    fd.append("businesses_id", details.businesses_id);
    fd.append("product_id", details.product_id);
    fd.append("have_group_sale", details.have_group_sale);
    fd.append("group_sale_endtime", details.group_sale_endtime);
    fd.append("submit_price_group", details.submit_price_group);
    fd.append("productPricing", x);
    fd.append("is_main_shop", type == "0" ? 1 : 0);
    situation.edit &&
      sendRequestAPI2("updateproductpriceing", fd).then(data => {
        if (data.data.status == 1) {
          toastFunction("success", "ویرایش با موفقیت انجام شد.");

          setShow(false);
          setUpdater(prev => !prev);
        } else {
          toastFunction("error", "متاسفانه مشکلی در ویرایش پیش آمده است.");
        }
      });

    situation.add &&
      sendRequest("addproductpriceing", {
        product_id: details.product_id,
        submit_price_group: details.submit_price_group,
        group_sale_endtime: details.group_sale_endtime,
        businesses_id: details.businesses_id,
        is_main_shop: type == "0" ? 1 : 0,
        // group_sales: saleTerms.groupSaleTerms.status ? 1 : 0,
        // have_group_sale: temp,
        have_group_sale: details.have_group_sale,
        productPricing: x
      });
  };

  const editProduct = async function() {
    const fd = new FormData();
    fd.append("pbl_id", details.id);
    fd.append("businesses_id", details.businesses_id);
    fd.append("product_id", details.product_id);
    fd.append("max_num", details.max_num);
    fd.append("step", details.step);
    fd.append("submit_price", details.submit_price);
    fd.append("main_price", details.main_price);
    fd.append("main_discount", details.main_discount);
    fd.append("itemcount", details.itemcount);
    fd.append("main_discount_endtime", details.main_discount_endtime);
    fd.append("is_single", details.is_single);

    sendRequestAPI2("edit_product_business_links", fd).then(data => {
      if (data.data.status == 1) {
        toastFunction("success", "ویرایش با موفقیت انجام شد.");

        setShow(false);
      } else {
        toastFunction("error", "متاسفانه مشکلی در ویرایش کالا پیش آمده است.");
      }
    });

    // for (let i = 0; i < details.renge.length; i++) {
    //   forms.append(`from_count_${i}`, details.renge[i].from_count);
    //   forms.append(`max_num_${i}`, details.renge[i].max_num);
    //   forms.append(`step_${i}`, details.renge[i].step);
    //   forms.append(`to_count_${i}`, details.renge[i].to_count);
    //   forms.append(`from_price_${i}`, details.renge[i].from_price);
    // }
    // for (var [key, value] of forms.entries()) {
    //   console.log(key, value);
    // }
    // } else {
    //   toast.error(
    //     "برای تعریف شرایط فروش جدید ، باید فروش محصولات قبلی تمام شود!"
    //   );
    // }
  };

  const validation = (type, maxCount, minCount, step, maxPerBuy, price) => {
    // console.log(
    //   "**",
    //   type,
    //   maxCount,
    //   minCount,
    //   step,
    //   maxPerBuy,
    //   priceRange,
    //   price
    // );
    let valid = true;
    let x = "";

    if (type == "single") {
      x = "is_single";
    } else if (type == "group") {
      x = "have_group_sale";
    }
    if (
      details[x] &&
      ((maxCount - minCount + 1) % step != 0 ||
        maxPerBuy == 0 ||
        maxPerBuy == "" ||
        (maxPerBuy != 0 && (maxCount - minCount + 1) % maxPerBuy != 0) ||
        maxPerBuy > maxCount - minCount + 1 ||
        step > maxCount - minCount + 1 ||
        (maxPerBuy != 0 && maxPerBuy % step != 0) ||
        step == 0 ||
        price > +priceRange.max ||
        price < +priceRange.min ||
        (type == "group" && maxCount <= minCount))
    ) {
      type == "group" &&
        setTextError({
          ...textError,
          [type]: (
            <ol>
              <li>قدم باید بر موجودی بخشپذیر باشد(حداقل قدم=1).</li>
              <li>قدم باید بر بیشترین میزان بخشپذیر باشد.</li>
              <li>قدم و بیشترین میزان باید کوچکتر مساوی موجودی باشد.</li>
              <li>
                قیمت باید بین {addCommas(priceRange.min)} و{" "}
                {addCommas(priceRange.max)} باشد.
              </li>
            </ol>
          )
        });
      type == "single" &&
        setSingleTxt({
          ...singleTxt,
          [type]: (
            <ol>
              <li>قدم باید بر موجودی بخشپذیر باشد.</li>
              <li>قدم باید بر بیشترین میزان بخشپذیر باشد.</li>
              <li>قدم و بیشترین میزان باید کوچکتر مساوی موجودی باشد.</li>
              <li>
                قیمت باید بین {addCommas(priceRange.min)} و{" "}
                {addCommas(priceRange.max)} باشد.
              </li>
            </ol>
          )
        });
      valid = false;
    } else {
      type == "group" &&
        setTextError({
          ...textError,
          [type]: ""
        });
      type == "single" &&
        setSingleTxt({
          ...singleTxt,
          [type]: ""
        });
    }
    return valid;
  };
  const submitValidation = () => {
    let v = true;
    if (
      type == "1" &&
      !validation(
        "single",
        details.itemcount,
        1,
        details.step,
        details.max_num,
        details.main_price - details.main_discount
      )
    ) {
      v = false;
    }
    for (let i = 0; i < details.renge.length; i++) {
      if (
        !validation(
          "group",
          details.renge[i].to_count,
          details.renge[i].from_count,
          details.renge[i].step,
          details.renge[i].max_num,
          details.renge[i].from_price
        )
      ) {
        v = false;
      }
    }
    return v;
  };
  useEffect(() => {
    if (
      details.renge.length > 0 &&
      // details.renge[0]?.saled_count &&
      details.renge[0]?.saled_count != "0"
    ) {
      setDisabledInput(true);
    } else {
      setDisabledInput(false);
    }
    if (details.renge.length == "0") {
      setSituation(prev => {
        return { ...prev, add: true };
      });
    } else if (
      details.renge.length > "0" &&
      details.renge[0]?.saled_count &&
      details.renge[0]?.saled_count == "0"
    ) {
      setSituation(prev => {
        return { ...prev, edit: true };
      });
    }
  }, [details]);
  useEffect(() => {
    setDetails({
      ...productDetail,
      submit_price_group: productDetail.renge[0]
        ? productDetail.renge[0].submit_price_group
        : 0
    });

    if (type == "0") {
      setPriceRange({
        min: productDetail.product[0].price_from,
        max: productDetail.product[0].price_to
      });
    } else if (type == "1") {
      setPriceRange({
        min: 0,
        max:
          +productDetail.product[0].price_from +
          (parseInt(productDetail.product[0].price_from) *
            parseInt(productDetail.product[0].Interest_rates)) /
            100
      });
    }
  }, [productDetail]);
  useEffect(() => {
    sendRequest("Find_productsInventory", {
      conditions: `product_id/=/${1}@@businesses_id/=/${1}`
    });
  }, []);
  // console.log("productDetail", productDetail);
  // console.log("saleTerms", saleTerms);
  // console.log(
  //   "details",
  //   details,
  //   disabledInput,
  //   details.renge.length,
  //   priceRange
  // );
  console.log("details", details);
  console.log("situation", situation);
  // console.log("disabledInput", disabledInput);
  // console.log(singleFlag, groupFlag);
  return (
    <div className="edit-product-admin mx-1" style={{ width: "180px" }}>
      {auth.isLogged &&
        auth.userInfo.id == productDetail.business[0]?.admin_id && (
          <button
            className="btn text-light success-button w-100 mx-1"
            onClick={() => {
              setShow(true);
            }}
          >
            <IoMdAddCircleOutline className="me-1" />
            ویرایش محصول
          </button>
        )}
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>ویرایش محصول</Modal.Header>
        <Modal.Body>
          <div className="edit-product-admin">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="addSale1-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#addSale1"
                  type="button"
                  role="tab"
                  aria-controls="addSale1"
                  aria-selected="true"
                >
                  شرایط فروش
                </button>
              </li>
              {productDetail?.business[0]?.type != "0" && (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="recordSale1-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#recordSale1"
                    type="button"
                    role="tab"
                    aria-controls="recordSale1"
                    aria-selected="false"
                  >
                    سابقه خرید
                  </button>
                </li>
              )}
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="addSale1"
                role="tabpanel"
                aria-labelledby="addSale1-tab"
              >
                <form className="">
                  <div className="d-flex mt-5 mb-4">
                    <h6 className="" style={{ width: "20%" }}>
                      نام محصول :
                    </h6>
                    <h6 className="mx-2" style={{ width: "80%" }}>
                      {details.product[0].title}
                    </h6>
                  </div>
                  {/* <div className="mb-3">
                  <label htmlFor="#freight-cost" className="form-label">
                    هزینه باربری
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name
                    id="freight-cost"
                    placeholder
                    
                  />
                </div> */}
                  {details.renge[0]?.saled_count &&
                    details.renge[0]?.saled_count != "0" && (
                      <p
                        style={{ fontSize: 13 }}
                        className="text-danger text-center mt-2"
                      >
                        امکان تغییر شرایط گروهی در حین فروش وجود ندارد.{" "}
                      </p>
                    )}
                  <div
                    className={`text-center text-danger my-2 `}
                    style={{ fontSize: 13 }}
                  >
                    {`قیمت این محصول میتواند بین ${addCommas(
                      priceRange.min
                    )} تا ${addCommas(priceRange.max)} تومان باشد.`}
                  </div>
                  {productDetail?.business[0]?.type != "0" && (
                    <>
                      <div className="form-check form-switch d-flex justify-content-between px-2 mt-4">
                        <label
                          className="form-check-label"
                          htmlFor="flexSwitchCheckDefaultSingle"
                        >
                          <h4 classname="mt-4">شرایط فروش تکی</h4>
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexSwitchCheckDefaultSingle"
                          checked={details.is_single == "0" ? false : true}
                          onChange={e => {
                            changeHandler(
                              "main",
                              "is_single",
                              e.target.checked ? "1" : "0",
                              ""
                            );
                          }}
                          data-for="gm-tooltip"
                          data-tip={tooltipSingle}
                        />
                      </div>
                      <p
                        style={{ fontSize: 13 }}
                        className="text-danger text-center mt-2"
                      >
                        {singleTxt.single}
                      </p>
                      {/* <h4 className="mt-4">شرایط فروش تکی</h4> */}
                      {details.is_single == "1" && (
                        <>
                          <div className="mb-3">
                            <label
                              htmlFor="delivery-price-1"
                              className="form-label"
                            >
                              هزینه ارسال
                            </label>
                            <input
                              // type="number"
                              className="form-control"
                              name
                              id="delivery-price-1"
                              placeholder
                              value={addCommas(details.submit_price)}
                              onChange={e => {
                                flagHandler("single");
                                changeHandler(
                                  "main",
                                  "submit_price",
                                  removeCommas(e.target.value)
                                );
                                // setSaleTerms((prev) => {
                                //   return {
                                //     ...prev,
                                //     singleSaleTerms: {
                                //       ...prev.singleSaleTerms,
                                //       deliveryPrice: e.target.value,
                                //     },
                                //   };
                                // });
                              }}
                            />
                            {/* <small>تومان</small> */}
                          </div>
                          <div className="mb-3">
                            <label htmlFor="main-price" className="form-label">
                              قیمت<span style={{ fontSize: 12 }}>(تومان)</span>
                            </label>
                            <input
                              // type="number"
                              className="form-control"
                              name
                              id="main-price"
                              value={addCommas(details.main_price)}
                              placeholder
                              onChange={e => {
                                flagHandler("single");
                                changeHandler(
                                  "main",
                                  "main_price",
                                  removeCommas(e.target.value)
                                );
                                priceChecker(removeCommas(e.target.value));
                                // setSaleTerms((prev) => {
                                //   return {
                                //     ...prev,
                                //     singleSaleTerms: {
                                //       ...prev.singleSaleTerms,
                                //       price: e.target.value,
                                //     },
                                //   };
                                // });
                              }}
                            />
                            {/* <small>تومان</small> */}
                          </div>
                          <div className="mb-3">
                            <label htmlFor="main-price" className="form-label">
                              مبلغ تخفیف{" "}
                            </label>
                            <input
                              // type="number"
                              className="form-control"
                              name
                              id="main-price"
                              placeholder
                              value={addCommas(details.main_discount)}
                              onChange={e => {
                                flagHandler("single");
                                changeHandler(
                                  "main",
                                  "main_discount",
                                  removeCommas(e.target.value)
                                );
                                // setSaleTerms((prev) => {
                                //   return {
                                //     ...prev,
                                //     singleSaleTerms: {
                                //       ...prev.singleSaleTerms,
                                //       discount: e.target.value,
                                //     },
                                //   };
                                // });
                              }}
                            />
                            {/* <small>تومان</small> */}
                          </div>
                          <div class="mb-3">
                            <label for="price-time" class="form-label">
                              زمان تخفیف
                            </label>
                            <DatePicker
                              id="price-time"
                              value={
                                +productDetail.main_discount_endtime * 1000
                              }
                              // value={1663197247000}
                              // value={new Date(1663197247000)}
                              onChange={e => {
                                flagHandler("single");
                                // console.log("time", e.unix);
                                changeHandler(
                                  "main",
                                  "main_discount_endtime",
                                  e.unix
                                );
                                // setSaleTerms((prev) => {
                                //   return {
                                //     ...prev,
                                //     singleSaleTerms: {
                                //       ...prev.singleSaleTerms,
                                //       discountDateFrom: e[0]?.unix,
                                //       discountDateTo: e[1]?.unix,
                                //     },
                                //   };
                                // });
                              }}
                              // range
                              calendar={persian}
                              locale={persian_fa}
                              calendarPosition="bottom-right"
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="inventory" className="form-label">
                              موجودی
                            </label>
                            <input
                              // type="number"
                              className="form-control"
                              name
                              id="inventory"
                              placeholder
                              value={details.itemcount}
                              onChange={e => {
                                flagHandler("single");
                                changeHandler(
                                  "main",
                                  "itemcount",
                                  e.target.value
                                );
                                // setSaleTerms((prev) => {
                                //   return {
                                //     ...prev,
                                //     singleSaleTerms: {
                                //       ...prev.singleSaleTerms,
                                //       discount: e.target.value,
                                //     },
                                //   };
                                // });
                              }}
                            />
                            {/* <small>تومان</small> */}
                          </div>
                          <div className="mb-3 d-flex">
                            {/* <div className="mb-3 mx-3">
                    <label htmlFor="min-count" className="form-label">
                      کمترین میزان
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name
                      id="min-count"
                      aria-describedby="helpId"
                      placeholder
                      value={details.min_num}
                      onChange={(e) => {
                        changeHandler("main", "min_num", e.target.value);
                        // setSaleTerms((prev) => {
                        //   return {
                        //     ...prev,
                        //     singleSaleTerms: {
                        //       ...prev.singleSaleTerms,
                        //       minCount: e.target.value,
                        //     },
                        //   };
                        // });
                      }}
                    />
                  </div> */}

                            <div className="mb-3 mx-3">
                              <label htmlFor="max-count" className="form-label">
                                بیشترین میزان
                              </label>
                              <input
                                type="number"
                                id="max-count"
                                className="form-control"
                                min={details.step}
                                step={details.step}
                                value={details.max_num}
                                onChange={e => {
                                  flagHandler("single");
                                  changeHandler(
                                    "main",
                                    "max_num",
                                    e.target.value
                                  );
                                  // setSaleTerms((prev) => {

                                  //   return {
                                  //     ...prev,
                                  //     singleSaleTerms: {
                                  //       ...prev.singleSaleTerms,
                                  //       maxCount: e.target.value,
                                  //     },
                                  //   };
                                  // });
                                }}
                                placeholder
                              />
                            </div>
                            <div className="mb-3 mx-3">
                              <label htmlFor="step" className="form-label">
                                قدم
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name
                                id="step"
                                // min={details.min_num}
                                min="1"
                                value={details.step}
                                onChange={e => {
                                  flagHandler("single");
                                  changeHandler("main", "step", e.target.value);
                                  // setSaleTerms((prev) => {
                                  //   return {
                                  //     ...prev,
                                  //     singleSaleTerms: {
                                  //       ...prev.singleSaleTerms,
                                  //       step: e.target.value,
                                  //     },
                                  //   };
                                  // });
                                }}
                                placeholder
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {/* شرایط فروش گروهی */}
                  <div className="form-check form-switch d-flex justify-content-between mt-2 px-2">
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      <h4 classname="mt-4">شرایط فروش گروهی</h4>
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      disabled={disabledInput}
                      checked={details.have_group_sale == "1" ? true : false}
                      id="flexSwitchCheckDefault"
                      onChange={e => {
                        changeHandler(
                          "main",
                          "have_group_sale",
                          e.target.checked ? "1" : "0",
                          ""
                        );
                        // setSaleTerms((prev) => {
                        //   return {
                        //     ...prev,
                        //     groupSaleTerms: {
                        //       ...prev.groupSaleTerms,
                        //       status: e.target.checked,
                        //     },
                        //   };
                        // });
                      }}
                      data-for="gm-tooltip"
                      data-tip={tooltipGroup}
                    />
                  </div>
                  <p
                    className="text-danger text-center"
                    style={{ fontSize: 13 }}
                  >
                    {validateTxt}
                  </p>
                  <p
                    style={{ fontSize: 13 }}
                    className="text-danger text-center mt-2"
                  >
                    {textError.group}
                  </p>
                  {details.have_group_sale == "1" && (
                    <>
                      <div className="mb-3">
                        <label
                          htmlFor="delivery-price-2"
                          className="form-label"
                        >
                          هزینه ارسال
                          <span style={{ fontSize: 12 }}>(تومان)</span>
                        </label>
                        <input
                          // type="number"
                          className="form-control"
                          name
                          disabled={disabledInput}
                          id="delivery-price-2"
                          // value={addCommas(
                          //   details.renge.length > 0
                          //     ? details.renge[0].submit_price_group
                          //     : 0
                          // )}
                          value={addCommas(details.submit_price_group)}
                          onChange={e => {
                            flagHandler("group");
                            changeHandler(
                              "main",
                              "submit_price_group",
                              removeCommas(e.target.value),
                              0
                            );
                            // changeHandler(
                            //   "range",
                            //   "submit_price_group",
                            //   removeCommas(e.target.value),
                            //   0
                            // );
                            // setSaleTerms((prev) => {
                            //   return {
                            //     ...prev,
                            //     groupSaleTerms: {
                            //       ...prev.groupSaleTerms,
                            //       deliveryPrice: e.target.value,
                            //     },
                            //   };
                            // });
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="delivery-price-2"
                          className="form-label"
                        >
                          زمان اتمام فروش گروهی
                        </label>
                        <DatePicker
                          id="price-time"
                          // value={new Date(productDetail.main_discount_endtime * 1000)}
                          value={+productDetail.group_sale_endtime * 1000}
                          disabled={disabledInput}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          onChange={e => {
                            flagHandler("group");
                            changeHandler("main", "group_sale_endtime", e.unix);
                          }}
                        />
                      </div>
                      <div
                        className={`mb- d-flex ${
                          disabledInput ? "d-none" : "d-block"
                        }`}
                      >
                        <span
                          style={{
                            cursor: "pointer",
                            border: "1px solid #f2ede1",
                            borderRadius: "5px",
                            padding: "0px 10px"
                          }}
                          onClick={e => {
                            let x = details.renge.length;

                            if (x > 2) {
                              toast.error(
                                "امکان تعریف بیش از 3 رنج وجود ندارد."
                              );
                            } else if (
                              x == 0 ||
                              (x > 0 &&
                                validation(
                                  "group",
                                  details.renge[x - 1].to_count,
                                  details.renge[x - 1].from_count,
                                  details.renge[x - 1].step,
                                  details.renge[x - 1].max_num,
                                  details.renge[x - 1].from_price
                                ))
                              // (x > 0 &&
                              //   +details.renge[x - 1].to_count >
                              //     +details.renge[x - 1].from_count &&
                              //   +details.renge[x - 1].step >= 1 &&
                              //   +details.renge[x - 1].step <=
                              //     +details.renge[x - 1].to_count -
                              //       +details.renge[x - 1].from_count +
                              //       1 &&
                              //   (+details.renge[x - 1].to_count -
                              //     +details.renge[x - 1].from_count +
                              //     1) %
                              //     +details.renge[x - 1].step ==
                              //     0 &&
                              //   +details.renge[x - 1].max_num >=
                              //     +details.renge[x - 1].step &&
                              //   +details.renge[x - 1].max_num %
                              //     +details.renge[x - 1].step ==
                              //     0 &&
                              //   +details.renge[x - 1].max_num <=
                              //     +details.renge[x - 1].to_count -
                              //       +details.renge[x - 1].from_count +
                              //       1)
                            ) {
                              // setValidateTxt(false);
                              setDetails(prev => {
                                return {
                                  ...prev,
                                  renge: [
                                    ...details.renge,
                                    {
                                      from_count:
                                        x != 0
                                          ? +details.renge[x - 1].to_count + 1
                                          : 1,
                                      from_price: "0",

                                      max_num: "0",
                                      min_num: "0",

                                      step: "1",

                                      to_count:
                                        x == 0
                                          ? 2
                                          : +details.renge[x - 1].to_count + 2,

                                      to_price: "0",
                                      saled_count: "0"
                                    }
                                  ]
                                };
                              });
                            } else {
                              // setValidateTxt(true);
                            }
                            // if (
                            //   saleTerms.groupSaleTerms.rangeList.at(-1).min <
                            //   saleTerms.groupSaleTerms.rangeList.at(-1).max
                            // ) {
                            //   setSaleTerms((prev) => {
                            //     return {
                            //       ...prev,
                            //       groupSaleTerms: {
                            //         ...prev.groupSaleTerms,
                            //         rangeList: [
                            //           ...prev.groupSaleTerms.rangeList,
                            //           {
                            //             min:
                            //               +prev.groupSaleTerms.rangeList.at(-1).max +
                            //               1,
                            //             max:
                            //               +prev.groupSaleTerms.rangeList.at(-1).max +
                            //               2,
                            //             price: "",
                            //           },
                            //         ],
                            //       },
                            //     };
                            //   });
                            // }
                          }}
                        >
                          <GoDiffAdded
                            style={{
                              color: "green",
                              borderRadius: "30%",
                              marginLeft: "10px"
                            }}
                          ></GoDiffAdded>
                          افزودن رنج
                        </span>
                        {/* <p className="mx-auto validation-text">{validateTxt}</p> */}
                      </div>
                      {details.renge.map((value, index) => {
                        let min_count_range =
                          index != 0
                            ? details.renge[index - 1].to_count
                            : "any";
                        return (
                          <div
                            className={`mb-3 ${!isLastRange(index) &&
                              "edit-product-admin-disabled-item "}`}
                          >
                            <div
                              className={`d-flex flex-wrap justify-content-between align-items-center mt-4 
                      "active-progress_active"
                         
                    `}
                            >
                              <span className="text-center">
                                <input
                                  type="number"
                                  className="form-control "
                                  disabled={disabledInput}
                                  style={{ width: "80px" }}
                                  // min={+value.min_num + +value.from_count}
                                  // step={value.step}
                                  value={details.renge[index].to_count}
                                  // value={value.to_count}

                                  onChange={e => {
                                    flagHandler("group");
                                    if (isLastRange(index)) {
                                      changeHandler(
                                        "range",
                                        "to_count",
                                        e.target.value,
                                        index
                                      );
                                    }

                                    // if (isLastRange(index)) {
                                    //   let temp = [
                                    //     ...saleTerms.groupSaleTerms.rangeList,
                                    //   ];
                                    //   temp[index].max = e.target.value;

                                    //   // setSaleTerms((prev) => {
                                    //   //   return {
                                    //   //     ...prev,
                                    //   //     groupSaleTerms: {
                                    //   //       ...prev.groupSaleTerms,
                                    //   //       rangeList: [...temp],
                                    //   //     },
                                    //   //   };
                                    //   // });
                                    // }
                                  }}
                                />
                                <small>بیشینه تعداد</small>
                              </span>
                              <span className="text-center ">
                                <input
                                  // type="number"
                                  className="form-control"
                                  style={{ width: "120px" }}
                                  disabled={disabledInput}
                                  // value={value.price}
                                  value={addCommas(value.from_price)}
                                  onChange={e => {
                                    flagHandler("group");
                                    if (isLastRange(index)) {
                                      changeHandler(
                                        "range",
                                        "from_price",
                                        removeCommas(e.target.value),
                                        index
                                      );
                                    }

                                    priceChecker(removeCommas(e.target.value));
                                    // if (isLastRange(index)) {
                                    //   let temp = [
                                    //     ...saleTerms.groupSaleTerms.rangeList,
                                    //   ];
                                    //   temp[index].price = e.target.value;
                                    //   // setSaleTerms((prev) => {
                                    //   //   return {
                                    //   //     ...prev,
                                    //   //     groupSaleTerms: {
                                    //   //       ...prev.groupSaleTerms,
                                    //   //       rangeList: [...temp],
                                    //   //     },
                                    //   //   };
                                    //   // });
                                    // }
                                  }}
                                />
                                <small>
                                  قیمت
                                  <span style={{ fontSize: 12 }}>(تومان)</span>
                                </small>
                              </span>
                              <span className="text-center ">
                                <input
                                  type="number"
                                  disabled={disabledInput}
                                  className="form-control"
                                  style={{ width: "80px" }}
                                  // value={value.min}
                                  min={min_count_range}
                                  value={value.from_count}
                                  onChange={e => {
                                    flagHandler("group");
                                    // if (
                                    //   index == 0 &&
                                    //   saleTerms.groupSaleTerms.rangeList.length == 1
                                    // ) {
                                    //   let temp = [
                                    //     ...saleTerms.groupSaleTerms.rangeList,
                                    //   ];
                                    //   temp[index].min = e.target.value;
                                    //   // setSaleTerms((prev) => {
                                    //   //   return {
                                    //   //     ...prev,
                                    //   //     groupSaleTerms: {
                                    //   //       ...prev.groupSaleTerms,
                                    //   //       rangeList: [...temp],
                                    //   //     },
                                    //   //   };
                                    //   // });
                                    // }
                                  }}
                                />
                                <small>کمینه تعداد</small>
                              </span>
                            </div>
                            <div dir="ltr" className="progress my-1 bg-light">
                              {isLastRange(index) && (
                                <span
                                  className={`${
                                    disabledInput ? "d-none" : "d-block"
                                  }`}
                                  style={{ fontSize: "14px" }}
                                  onClick={() => {
                                    let temp = details.renge;
                                    temp.pop();
                                    setDetails(prev => {
                                      return { ...prev, renge: temp };
                                    });
                                    // let temp = [
                                    //   ...saleTerms.groupSaleTerms.rangeList,

                                    // ];

                                    // temp.pop();
                                    // setSaleTerms((prev) => {
                                    //   return {
                                    //     ...prev,
                                    //     groupSaleTerms: {
                                    //       ...prev.groupSaleTerms,
                                    //       rangeList: [...temp],
                                    //     },
                                    //   };
                                    // });
                                  }}
                                >
                                  <IoIosRemoveCircleOutline
                                    style={{ marginButton: "10px" }}
                                  ></IoIosRemoveCircleOutline>
                                </span>
                              )}

                              <div
                                dir="ltr"
                                id="progress-bar"
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${100}% `
                                }}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            {/* {isLastRange(index) &&
                        saleTerms.groupSaleTerms.rangeList[index].min >=
                          saleTerms.groupSaleTerms.rangeList[index].max && (
                          <small style={{ color: "red" }}>
                            بیشینه باید کمتر از کمینه باشد.
                          </small>
                        )} */}
                            <div className="mb-3 d-flex">
                              {/* <div className="mb-3 mx-3">
                          <label
                            htmlFor={`min-count-${index}`}
                            className="form-label"
                          >
                            کمترین میزان
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name
                            id={`min-count-${index}`}
                            aria-describedby="helpId"
                            placeholder
                            value={value.min_num}
                            // value={
                            //   saleTerms.groupSaleTerms.rangeList[index].minCount
                            // }
                            onChange={(e) => {
                              changeHandler(
                                "range",
                                "min_num",
                                e.target.value,
                                index
                              );
                              // if (isLastRange(index)) {
                              //   let temp = [
                              //     ...saleTerms.groupSaleTerms.rangeList,
                              //   ];
                              //   temp[index].minCount = e.target.value;
                              //   // setSaleTerms((prev) => {
                              //   //   return {
                              //   //     ...prev,
                              //   //     groupSaleTerms: {
                              //   //       ...prev.groupSaleTerms,
                              //   //       rangeList: [...temp],
                              //   //     },
                              //   //   };
                              //   // });
                              // }
                            }}
                          />
                        </div> */}

                              <div className="mb-3 mx-3">
                                <label
                                  htmlFor={`max-count-${index}`}
                                  className="form-label"
                                >
                                  بیشترین میزان
                                </label>
                                <input
                                  type="number"
                                  id={`max-count-${index}`}
                                  disabled={disabledInput}
                                  min={value.min_num}
                                  step={value.step}
                                  // value={value.max_num}
                                  value={details.renge[index].max_num}
                                  className="form-control"
                                  // value={
                                  //   saleTerms.groupSaleTerms.rangeList[index].maxCount
                                  // }
                                  onChange={e => {
                                    flagHandler("group");
                                    if (isLastRange(index)) {
                                      changeHandler(
                                        "range",
                                        "max_num",
                                        e.target.value,
                                        index
                                      );
                                    }

                                    // if (isLastRange(index)) {
                                    //   let temp = [
                                    //     ...saleTerms.groupSaleTerms.rangeList,
                                    //   ];
                                    //   temp[index].maxCount = e.target.value;
                                    //   // setSaleTerms((prev) => {
                                    //   //   return {
                                    //   //     ...prev,
                                    //   //     groupSaleTerms: {
                                    //   //       ...prev.groupSaleTerms,
                                    //   //       rangeList: [...temp],
                                    //   //     },
                                    //   //   };
                                    //   // });
                                    // }
                                  }}
                                />
                              </div>
                              <div className="mb-3 mx-3">
                                <label
                                  htmlFor={`step-${index}`}
                                  className="form-label"
                                >
                                  قدم
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  disabled={disabledInput}
                                  // value={
                                  //   saleTerms.groupSaleTerms.rangeList[index].step
                                  // }
                                  // min={value.min_num}
                                  min="1"
                                  name
                                  value={value.step}
                                  id={`step-${index}`}
                                  onChange={e => {
                                    flagHandler("group");
                                    if (isLastRange(index)) {
                                      changeHandler(
                                        "range",
                                        "step",
                                        e.target.value,
                                        index
                                      );
                                    }

                                    // if (isLastRange(index)) {
                                    //   let temp = [
                                    //     ...saleTerms.groupSaleTerms.rangeList,
                                    //   ];
                                    //   temp[index].step = e.target.value;
                                    //   // setSaleTerms((prev) => {
                                    //   //   return {
                                    //   //     ...prev,
                                    //   //     groupSaleTerms: {
                                    //   //       ...prev.groupSaleTerms,
                                    //   //       rangeList: [...temp],
                                    //   //     },
                                    //   //   };
                                    //   // });
                                    // }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div>
                        {/* {saleTerms.groupSaleTerms.rangeList.map((value, index) => {
                  return (
                    <div
                      className={`mb-3 ${
                        !isLastRange(index) && "edit-product-admin-disabled-item"
                      }`}
                    >
                      <div
                        className={`d-flex justify-content-between align-items-center mt-4 
                      "active-progress_active"
                         
                    `}
                      >
                        <span className="text-center">
                          <input
                            type="number"
                            className="form-control"
                            style={{ width: "50px" }}
                            value={value.max}
                            onChange={(e) => {
                              if (isLastRange(index)) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].max = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                          <small>بیشینه تعداد</small>
                        </span>
                        <span className="text-center ">
                          <input
                            type="number"
                            className="form-control"
                            style={{ width: "100px" }}
                            value={value.price}
                            onChange={(e) => {
                              if (isLastRange(index)) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].price = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                          <small>قیمت</small>
                        </span>
                        <span className="text-center ">
                          <input
                            type="number"
                            className="form-control"
                            style={{ width: "50px" }}
                            value={value.min}
                            onChange={(e) => {
                              if (
                                index == 0 &&
                                saleTerms.groupSaleTerms.rangeList.length == 1
                              ) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].min = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                          <small>کمینه تعداد</small>
                        </span>
                      </div>
                      <div dir="ltr" className="progress my-1 bg-light">
                        {isLastRange(index) && index != 0 && (
                          <span
                            style={{ fontSize: "14px" }}
                            onClick={() => {
                              let temp = [
                                ...saleTerms.groupSaleTerms.rangeList,
                              ];
                              temp.pop();
                              setSaleTerms((prev) => {
                                return {
                                  ...prev,
                                  groupSaleTerms: {
                                    ...prev.groupSaleTerms,
                                    rangeList: [...temp],
                                  },
                                };
                              });
                            }}
                          >
                            <IoIosRemoveCircleOutline
                              style={{ marginButton: "10px" }}
                            ></IoIosRemoveCircleOutline>
                          </span>
                        )}

                        <div
                          dir="ltr"
                          id="progress-bar"
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${100}% `,
                          }}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      {isLastRange(index) &&
                        saleTerms.groupSaleTerms.rangeList[index].min >=
                          saleTerms.groupSaleTerms.rangeList[index].max && (
                          <small style={{ color: "red" }}>
                            بیشینه باید کمتر از کمینه باشد.
                          </small>
                        )}
                      <div className="mb-3 d-flex">
                        <div className="mb-3 mx-3">
                          <label
                            htmlFor={`min-count-${index}`}
                            className="form-label"
                          >
                            کمترین میزان
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name
                            id={`min-count-${index}`}
                            aria-describedby="helpId"
                            placeholder
                            value={
                              saleTerms.groupSaleTerms.rangeList[index].minCount
                            }
                            onChange={(e) => {
                              if (isLastRange(index)) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].minCount = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="mb-3 mx-3">
                          <label
                            htmlFor={`max-count-${index}`}
                            className="form-label"
                          >
                            بیشترین میزان
                          </label>
                          <input
                            type="number"
                            id={`max-count-${index}`}
                            className="form-control"
                            value={
                              saleTerms.groupSaleTerms.rangeList[index].maxCount
                            }
                            onChange={(e) => {
                              if (isLastRange(index)) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].maxCount = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="mb-3 mx-3">
                          <label
                            htmlFor={`step-${index}`}
                            className="form-label"
                          >
                            قدم
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={
                              saleTerms.groupSaleTerms.rangeList[index].step
                            }
                            name
                            id={`step-${index}`}
                            onChange={(e) => {
                              if (isLastRange(index)) {
                                let temp = [
                                  ...saleTerms.groupSaleTerms.rangeList,
                                ];
                                temp[index].step = e.target.value;
                                setSaleTerms((prev) => {
                                  return {
                                    ...prev,
                                    groupSaleTerms: {
                                      ...prev.groupSaleTerms,
                                      rangeList: [...temp],
                                    },
                                  };
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })} */}
                      </div>
                    </>
                  )}
                  {/* <p
                    className={`mt-2 ${
                      validateTxt == false ? "d-none" : "d-block"
                    }`}
                    style={{ fontSize: "14px", color: "maroon" }}
                  >
                    در رنج آخر یکی از این موارد رعایت نشده است:
                    <ul className="mt-1">
                      <li>بیشینه تعداد باید از کمینه تعداد بیشتر باشد.</li>
                      <li>
                        بیشینه تعداد و بیشترین میزان باید ضریبی از قدم باشند.
                      </li>
                      <li>قدم باید از 1 بیشتر و از موجودی رنج کمتر باشد.</li>
                      <li>بیشترین میزان باید مساوی یا بزرگتر از قدم باشد.</li>
                    </ul>
                  </p> */}

                  <div className="d-flex">
                    <button
                      className="btn bg-success text-light ms-auto"
                      onClick={async e => {
                        e.preventDefault();
                        if (
                          details.have_group_sale == "1" &&
                          !disabledInput &&
                          (details.group_sale_endtime == "" ||
                            details.renge.length < 2 ||
                            details.submit_price_group == "")
                          // (details.renge?.submit_price_group &&
                          //   details.renge?.submit_price_group == ""))
                        ) {
                          setValidateTxt(
                            <>
                              برای ثبت شرایط گروهی باید حداقل دو رنج مشخص کنید.
                              <br />
                              زمان اتمام شرایط فروش گروهی و هزینه ارسال نیز باید
                              مشخص باشد.
                            </>
                          );
                        } else {
                          setValidateTxt("");

                          if (submitValidation()) {
                            if (type == "1" && (await checkInventory())) {
                              singleFlag && (await editProduct());
                              !disabledInput &&
                                groupFlag &&
                                (await groupEditProduct());
                            } else if (type == "0") {
                              !disabledInput
                                ? await groupEditProduct()
                                : toast.error(
                                    "تغییر شرایط گروهی امکان پذیر نیست"
                                  );
                            }
                          }
                        }
                      }}
                    >
                      ویرایش
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="recordSale1"
                role="tabpanel"
                aria-labelledby="recordSale1-tab"
              >
                <div className="d-flex flex-row flex-wrap shadow rounded info-item mt-5">
                  <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center border-bottom-title">
                      زمان خرید
                    </h6>
                    <h6 className=" fs-12 text-center pt-1 caption">
                      {/* {selectedProduct.mainshop_commission} */}
                      14
                    </h6>
                  </div>
                  <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center border-bottom-title">
                      تعداد کل
                    </h6>
                    <h6 className=" fs-12 text-center pt-1 caption">
                      {/* {selectedProduct.mainshop_commission} */}
                      14
                    </h6>
                  </div>
                  <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center border-bottom-title">
                      موجودی فعال
                    </h6>
                    <h6 className="  fs-12 text-center pt-1 caption">
                      {/* {selectedProduct.mainshop_commission} */}
                      15
                    </h6>
                  </div>
                  <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center border-bottom-title">
                      تعداد فروخته شده{" "}
                    </h6>
                    <h6 className=" fs-12 text-center pt-1 caption">
                      {/* {selectedProduct.mainshop_commission} */}
                      16
                    </h6>
                  </div>
                  <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center border-bottom-title-end">
                      درصد کمیسیون{" "}
                    </h6>
                    <h6 className=" fs-12 text-center pt-1caption">
                      {/* {selectedProduct.mainshop_commission} */}
                      17
                    </h6>
                  </div>
                  {/* <div className="flex-grow-1 ">
                    <h6 className="pt-2 fs-12 text-center">
                      فروشگاهی که خرید انجام شده
                    </h6>
                    <h6 className=" fs-12 text-center pt-1">
                      {selectedProduct.mainshop_commission}
                      18
                    </h6>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default EditProductAdmin;
